interface PlayerServerDotsProps {
  isServer: boolean;
  showSecondDot: boolean;
  matchStatus: number;
}
export const PlayerServerDots = ({
  isServer,
  showSecondDot,
  matchStatus,
}: PlayerServerDotsProps) => {
  return matchStatus === 2 ? (
    <div className='min-h-4 flex items-center justify-center'>
      {isServer ? (
        <div className='flex gap-1'>
          <div className='size-4 rounded-full bg-error-600' />
          {showSecondDot ? <div className='size-4 rounded-full bg-error-600' /> : null}
        </div>
      ) : null}
    </div>
  ) : null;
};
